import React from "react";
import { useGameRoyalties } from "@seabrookstudios/pitch2table";
import { useGameIdFromRoute } from "../WithGameIdFromRoute";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../../core/useMakeLayout";
import { RoyaltyFromRoute } from "./RoyaltyFromRoute";
import AddRoyaltyAction from "./AddRoyaltyAction";
import { useMyProfile } from "@seabrookstudios/pitch2table";
import { Path } from "../../Path";
import { NoRoyalties } from "../../royalties/NoRoyalties";
import { RoyaltyTotals } from "../../royalties/RoyaltyTotals";
import { preferredCurrencySet } from "@seabrookstudios/pitch2table-core";
import { GameRoyaltiesListEntry } from "../../royalties/ListEntry";
import { RoyaltiesByYearForGameChart } from "./Chart";

const RoyaltiesListHeader = ({ gameId, royalties }) => (
  <>
    <RoyaltiesByYearForGameChart gameId={gameId} />
    <RoyaltyTotals royalties={royalties} />
  </>
);

export const RoyaltiesListAndDetail = () => {
  const gameId = useGameIdFromRoute();
  const { data: royalties = [] } = useGameRoyalties(gameId);
  const { data: profile } = useMyProfile();

  const initialCurrency = profile?.currencySettings?.preferredCurrency || "USD";
  const Action = () => <AddRoyaltyAction id="add-royalty" gameId={gameId} initialCurrency={initialCurrency} />;

  const useWrappedQuery = () => useGameRoyalties(gameId);

  const useMakeList = useMakeListBuilder(
    (props) => <GameRoyaltiesListEntry gameId={gameId} {...props} />,
    idExtractor,
    "Royalties",
    NoRoyalties,
    preferredCurrencySet(profile) ? Action : undefined,
    () => <RoyaltiesListHeader gameId={gameId} royalties={royalties} />,
    Path.game(gameId).link()
  );

  const ListAndDetail = useMakeListAndDetail(useWrappedQuery, [], "royalties", useMakeList, RoyaltyFromRoute);

  return <ListAndDetail />;
};
